module.exports = __webpack_public_path__ + "static/media/about_us.724e602b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about_us.jpg
// module id = 746
// module chunks = 0